import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { StickersPage } from "@/features/gamification/components/stickers-page";
import { useI18n } from "@/providers/i18n-provider";

// Mis stickers coleccionados (screen #29) — parte de gamificación del tab Journal.
function StickersRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tus stickers`)}
      description={t(msg`Inicia sesión para coleccionar stickers exclusivos y completar álbumes.`)}
    >
      <StickersPage />
    </AuthPlaceholder>
  );
}

export const stickersRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/stickers",
  component: StickersRoutePage,
});
